// extracted by mini-css-extract-plugin
export var text = "BasicText-module--text--d60cd";